/* eslint-disable max-len */
import styled from 'styled-components';
import { MulticolorBarStyled } from '../../../components/ProgressIndicators/MulticolorBar/MulticolorBar.styles';
import { AllieEllipse } from '../../../components/Ellipse';
import { AllieText } from '../../../components/Text';
import { getCssVar } from '../../../common/utils';
import { DataContainerProps } from './ProductionShift.types';

export const StyledProductionShift = styled.div<{ isMobile?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: ${(props) =>
    props.isMobile
      ? '0 var(--allie-spacing-md) var(--allie-spacing-md)'
      : 'var(--allie-spacing-md)'};
`;

export const StyledProductionContent = styled.div<{ isMobile?: boolean; isTablet?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: ${({ isMobile, isTablet }) =>
    isMobile || isTablet ? 'space-evenly' : 'center'};
  row-gap: var(--allie-spacing-md);
  margin: 8px 0;
`;

export const POProgressBar = styled.div<{ height?: string }>`
  position: relative;
  border-radius: 100px;
  background-color: var(--allie-color-neutral-5);
  border: 1px solid var(--allie-color-neutral-30);
  height: ${({ height }) => height ?? '15px'};
  width: 100%;
  font-size: 14px;
  line-height: 16px;

  & div:last-child {
    height: ${({ height }) => height ?? '15px'};
    font-size: 14px;
    line-height: 16px;

    @media (min-width: ${() => getCssVar('--allie-xl-screen', '1600px')}) {
      font-size: 16px !important;
    }

    @media (min-width: ${() => getCssVar('--allie-xxl-screen', '1920px')}) {
      font-size: 18px !important;
    }

    & > ion-text {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
    }
  }

  ${MulticolorBarStyled} {
    width: 100%;
  }
`;

export const DataContainer = styled.div<DataContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: ${({ fullWidth }) => (fullWidth ? 1 : 0)};
`;

export const StyledLabel = styled(AllieText)`
  @media (min-width: ${() => getCssVar('--allie-xl-screen', '1600px')}) {
    font-size: 14px !important;
    line-height: 20px;
  }

  @media (min-width: ${() => getCssVar('--allie-xxl-screen', '1920px')}) {
    font-size: 16px !important;
    line-height: 23px;
  }
`;

export const StyledShiftValue = styled(AllieText)`
  @media (min-width: ${() => getCssVar('--allie-xl-screen', '1600px')}) {
    font-size: 24px !important;
    line-height: 34px;
  }

  @media (min-width: ${() => getCssVar('--allie-xxl-screen', '1920px')}) {
    font-size: 26px !important;
    line-height: 37px;
  }
`;

export const StyledShiftEllipsisText = styled(AllieEllipse)`
  font-size: 14px;
  line-height: 16px;
  @media (min-width: ${() => getCssVar('--allie-xl-screen', '1600px')}) {
    font-size: 16px !important;
  }

  @media (min-width: ${() => getCssVar('--allie-xxl-screen', '1920px')}) {
    font-size: 18px !important;
  }
`;

export const ProductionValueContainer = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: ${({ fullWidth }) => (fullWidth ? 1 : 0)};

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: var(--allie-radius-md);
    background-color: var(--allie-color-neutral-10);
  }
`;

export const StyledDivider = styled.div<{
  isMobile?: boolean;
  isTablet?: boolean;
  showDivider?: boolean;
}>`
  margin: 0 var(--allie-spacing-xl);
  height: auto;
  border-left: 1px solid var(--allie-color-light-40);
  display: ${({ isMobile, isTablet, showDivider }) => 
    ((!isMobile && !isTablet) || showDivider) ? 'block' : 'none'};
`;
